import axios from "axios";
import Cookies from "universal-cookie";
const node_env_var: any = {
  development: process.env.REACT_APP_API_Base_URL,
  production: process.env.REACT_APP_API_Base_URL_PROD,
};
const axiosInstance = axios.create({
  baseURL: node_env_var[process.env.NODE_ENV],
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    let token: any;

    if (cookies.get("access_token_demo")) {
      token = cookies.get("access_token_demo");
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response: any) => {
    let res: any = { data: null, message: "" };
    if (Array.isArray(response.data?.data)) {
      res.data = [...response.data?.data];
    } else {
      res.data = { ...response.data?.data };
    }
    res.message = response.data.message;
    return res;
  },
  async (error) => {
    const prevRequest = error?.config;
    const cookies = new Cookies();

    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      cookies.remove("access_token_demo");
      cookies.remove("refresh_token_demo");
      window.location.href = "/login";
    }
    return Promise.reject({
      error: error?.response,
      message: error?.response?.data?.message,
    });
  }
);

export default axiosInstance;
